import React from 'react';
import './Reservas.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import ReservasData from '../../Components/Admin/ReservasData/ReservasData';

export default function Reservas() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <ReservasData />
                </div>
            </section>
        </div>
    );
}

